import FlashMessage from 'react-native-flash-message';
import { showMessage } from 'react-native-flash-message';
import { TimeoutError } from '~/errors';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later, or contact support if the issue persists.';
const TIMEOUT_ERROR_MESSAGE =
  "Oops, we're having some trouble reaching the server. Please check your network connection and try again.";

const DEBUG_SHOW_ERROR = false;

export function showError(error: Error, message?: string | null, notificationRef?: React.RefObject<FlashMessage>) {
  let notificationMessage = error instanceof TimeoutError ? TIMEOUT_ERROR_MESSAGE : message || DEFAULT_ERROR_MESSAGE;

  if (error && DEBUG_SHOW_ERROR) {
    notificationMessage += `\n${error.toString()}`;
  }

  if (notificationRef?.current) {
    notificationRef.current.showMessage({ message: notificationMessage, type: 'warning' });
  } else {
    showMessage({ message: notificationMessage, type: 'warning' });
  }
}
